import { EquipeClinicaDto } from "@shared/service-proxies/service-proxies";

export class StringUtils {
  static isNullOrEmpty(value: any): boolean {
    return value === undefined || value === null || value === '';
  }

  static onlyNumbers(value: string) {
    if(this.isNullOrEmpty(value)) return "";
    return value.replace(/[^0-9]*/g, '');
  }

  static getIntegrantes(equipe: EquipeClinicaDto): string {
    if (!equipe || !equipe.equipeProfissionais || equipe.equipeProfissionais.length === 0) {
      return "";
    }
    const nomes = equipe.equipeProfissionais.map(p => p.profissionalSaude.nome);
    const limiteNomes = 5;
    if (nomes.length <= limiteNomes) {
      return nomes.join(", ");
    }
    const nomesExibidos = nomes.slice(0, limiteNomes).join(", ");
    const restantes = nomes.length - limiteNomes;
    return `${nomesExibidos}... <b>+ ${restantes} profissionais de saúde</b>`;
  }

  static isEmailValido(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  static getBestRoute(role: string) {
    role = role.toUpperCase();
    switch (role) {
      case "PACIENTE":
        return "/app/paciente";
      case "FUNCIONARIO":
        return "/app/funcionario";
      case "CLINICA":
        return "/app/clinica";
      case "PROFISSIONALSAUDE":
        return "/app/profissional-saude";
      default:
        return "/app/administrativo";
    }
  }

  static getSituacao(status: string) {
    switch (status) {
      case 'pending':
        return 'Pendente';
      case 'approved':
        return 'Aprovada';
      case 'authorized':
        return 'Autorizada';
      case 'in_process':
        return 'Em Processamento';
      case 'in_mediation':
        return 'Em Mediação';
      case 'rejected':
        return 'Rejeitada';
      case 'cancelled':
        return 'Cancelada';
      case 'refunded':
        return 'Devolvida';
      case 'charged_back':
        return 'Cobrado de Volta';
      case 'processing-cancellation':
        return 'Processando Cancelamento';
      default: return "Sem assinatura"
    }
  }

  static validarEmail(email: string): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
}